import api from './api';

/**
 * Messages Service - API calls for messaging functionality
 */

const messageService = {
  /**
   * Send a message
   * @param {Object} data - { recipientId, subject, message }
   */
  sendMessage: (data) => api.post('/messages/send', data),

  /**
   * Send bulk message
   * @param {Object} data - { recipientIds, subject, message, sendToAll }
   */
  sendBulkMessage: (data) => api.post('/messages/send-bulk', data),

  /**
   * Get inbox (received messages)
   */
  getInbox: () => api.get('/messages/inbox'),

  /**
   * Get sent messages
   */
  getSentMessages: () => api.get('/messages/sent'),

  /**
   * Get unread message count
   */
  getUnreadCount: () => api.get('/messages/unread-count'),

  /**
   * Get available recipients based on user role
   */
  getAvailableRecipients: (audience) => api.get('/messages/recipients', {
    params: audience ? { audience } : {}
  }),

  /**
   * Mark a message as read
   * @param {number} messageId
   */
  markAsRead: (messageId) => api.patch(`/messages/${messageId}/read`),

  /**
   * Delete a message
   * @param {number} messageId
   */
  deleteMessage: (messageId) => api.delete(`/messages/${messageId}`)
};

export default messageService;
